export default {
    items: [],
    cbs: [],
    loading: false,
}